import React, { memo, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Modal from 'react/components/Modal/Modal';

import { getResourceTo } from 'react/utils/utils';
import { actionCreators } from 'react/api/actions/modals';

function LocalzLogDetailsModal() {
  const dispatch = useDispatch();

  const MODAL_KEY = 'localzLogDetails';
  const isOpen = useSelector((state) => state.modals.getIn([MODAL_KEY, 'isOpen']));
  const title = useSelector((state) => state.modals.getIn([MODAL_KEY, 'title']));

  const {
    routeKey,
    stopKey,
    routeDate,
    requestDate,
    status,
    message,
    actionPerformed,
    organizationKey
  } = useSelector((state) => state.modals.getIn([MODAL_KEY, 'data']).toJS());

  const statusIconDetails = useMemo(() => {
    const hasSucessStatus = String(status).charAt(0) === '2';

    return {
      testidType: hasSucessStatus ? 'success': 'error',
      className: hasSucessStatus ? 'statusSuccess': 'statusError',
      resourceType: hasSucessStatus ? 'SuccessText' : 'ErrorText'
    };
  }, [status]);

  const formatMessage = useCallback((jsonText) => {
    try {
      const messageParsed = JSON.parse(jsonText);

      return JSON.stringify(messageParsed, null, 2).replace(/"/g, '');
    } catch (error) {
      return jsonText;
    }
  }, []);

  const closeModal = useCallback(() => {
    dispatch(actionCreators.closeModal({
      modalKey: MODAL_KEY
    }));
  }, []);

  const ModalFooter = (
    <div className="footerModal">
      <button
        data-testid="close-logdetails-modal"
        type="button"
        className="btn-secondary"
        onClick={closeModal}
      >
        {getResourceTo('default.button.close')}
      </button>
    </div>
  );

  function getContainer() {
    let container = document
      .querySelector('.mainContainer .reactivo-tabs.gmTabs #logsDetailsModalWrapper');

    if (!container) {
      container = document.createElement('div');
      container.id = 'logsDetailsModalWrapper';

      document.querySelector('.mainContainer .reactivo-tabs.gmTabs').appendChild(container);
    }

    return container;
  }

  return (
    <Modal
      className="logDetailsModal"
      isOpen={isOpen}
      title={getResourceTo(title)}
      crossAxisBtn={false}
      footer={ModalFooter}
      closeModalFn={closeModal}
      parentSelector={() => getContainer()}
    >
      <div className="modalBody" data-testid="modal-logdetails-body">
        <div className="row">
          <div className="leftLogContent">
            <div className="sectionDetail">
              <p className="titleDetail">{getResourceTo('wglnIntegration.field.routeKey')}</p>
              <span data-testid="logdetails-routeKey">{routeKey}</span>
            </div>
            <div className="sectionDetail">
              <p className="titleDetail">{getResourceTo('wglnIntegration.field.organization')}</p>
              <span data-testid="logdetails-organization">{organizationKey}</span>
            </div>
            <div className="sectionDetail">
              <p className="titleDetail">{getResourceTo('wglnIntegration.field.routeDate')}</p>
              <span data-testid="logdetails-date">{routeDate}</span>
            </div>
            <div className="sectionDetail">
              <p className="titleDetail">{getResourceTo('wglnIntegration.field.actionPerformed')}</p>
              <span data-testid="logdetails-action-performed">{actionPerformed}</span>
            </div>
            <div className="sectionDetail">
              <p className="titleDetail">{getResourceTo('wglnIntegration.field.actionTime')}</p>
              <span data-testid="logdetails-requestDate">{requestDate}</span>
            </div>
            <div className="sectionDetail status">
              <p className="titleDetail">{getResourceTo('wglnIntegration.field.status')}</p>
              <div
                data-testid={`logdetails-icon-${statusIconDetails.testidType}`}
                className={statusIconDetails.className}>
                <span className="icon" />
                <span className="text">
                  {getResourceTo(`IntegrationLogModal.${statusIconDetails.resourceType}`)}
                </span>
              </div>
            </div>
          </div>
          <div className="rightLogContent">
            {stopKey && (
              <div className="sectionDetail">
                <p className="titleDetail">{getResourceTo('eventLog.stop')}</p>
                <span data-testid="logdetails-stopKey">{stopKey}</span>
              </div>
            )}
            <div className="sectionDetail requestBody">
              <p className="titleDetail">{getResourceTo('wglnIntegration.field.message')}</p>
              <span className="preRequest">
                <pre>{formatMessage(message)}</pre>
              </span>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default memo(LocalzLogDetailsModal);
